// 注册中心名称
const apiName = process.env.BUILD_ENV === 'dev' ? 'ec-pc-api' : 'ec-pc-api'
// 商品SKU API
const goods = {
   // 所属店铺下拉查询
   getProductToStore: {
    type: 'get',
    url: `${apiName}/product/getProductToStore`
  },
  // 系统配置分页查询
  listPage: {
    type: 'post',
    url: `${apiName}/config/listPage`
  },
  // 系统配置保存
  addConfig: {
    type: 'post',
    url: `${apiName}/config/addConfig`
  },
  // 系统配置删除
  deleteConfig: {
    type: 'get',
    url: `${apiName}/config/deleteConfig`
  },
  getBaseType: {
    type: 'get',
    url: `${apiName}/config/getBaseType`
  },
  // 上市时间维护分页查询
  marketDateListPage: {
    type: 'post',
    url: `${apiName}/marketDate/listPage`
  },
  // 上市时间维护根据商品编号查询商品名称
  marketDateGetGoodsName: {
    type: 'get',
    url: `${apiName}/marketDate/getGoodsName`
  },
  // 上市时间维护保存
  marketDateAddMarketDate: {
    type: 'post',
    url: `${apiName}/marketDate/addMarketDate`
  },
  // 上市时间维护根据ID查询数据
  marketDateGetGoodsMarketById: {
    type: 'get',
    url: `${apiName}/marketDate/getGoodsMarketById`
  },
  // 导入记录分页查询
  fileListPage: {
    type: 'post',
    url: `${apiName}/file/listPage`
  },
  // 导出txt
  downloadTxt: {
    type: 'get',
    url: `${apiName}/file/downloadTxt`
  },
  goodsQueryOptionType: {
    type: 'get',
    url: `${apiName}/goods/getOptions`
  },
  // 商品SKU查询
  goodsListPage: {
    type: 'post',
    url: `${apiName}/goods/list`
  },
  // A类下拉数据
  aClassSelect: {
    type: 'post',
    url: `${apiName}/goods/aClassSelect`
  },
  // (商品属性维护页面搜索)商品定位下拉数据
  goodsAttrLocationSelect: {
    type: 'post',
    url: `${apiName}/goods/goodsAttrLocationSelect`
  },
  // (sku查询页面搜索)商品定位下拉数据
  goodsLocationSelect: {
    type: 'post',
    url: `${apiName}/goods/goodsLocationSelect`
  },
  // 商品空间下拉数据
  goodsPlaceSelect: {
    type: 'post',
    url: `${apiName}/goods/goodsPlaceSelect`
  },
  imgEdit: {
    type: 'post',
    url: `${apiName}/goods/img/edit`
  },
  imgDelete: {
    type: 'post',
    url: `${apiName}/goods/img/delete`
  },
  // 发货周期列表
  deliveryCycleListPage: {
    type: 'post',
    url: `${apiName}/goods/delivery/list`
  },
  deliveryCycleAdd: {
    type: 'post',
    url: `${apiName}/goods/delivery/save`
  },
  getNameByCode: {
    type: 'get',
    url: `${apiName}/goods/delivery/getNameByCode`
  },
  deliveryCycleModify: {
    type: 'post',
    url: `${apiName}/goods/delivery/modify`
  },
  getOne: {
    type: 'get',
    url: `${apiName}/goods/delivery/getOne`
  },
  // 系统配置根据对象类型查询数据
  getConfigByOptionType: {
    type: 'get',
    url: `${apiName}/config/getConfigByOptionType`
  },
  // 清仓销售状态维护分页查询
  clearanceListPage: {
    type: 'post',
    url: `${apiName}/clearance/listPage`
  },
  // 清仓销售状态维护保存
  saveClearance: {
    type: 'post',
    url: `${apiName}/clearance/saveClearance`
  },
  // 清仓销售状态根据ID查询数据
  getGoodsClearanceById: {
    type: 'get',
    url: `${apiName}/clearance/getGoodsClearanceById`
  },
  // 店铺商品定位维护
  storeLocationListPage: {
    type: 'post',
    url: `${apiName}/storeLocation/listPage`
  },
  // 店铺商品定位维护所需枚举值
  storeLocationOptions: {
    type: 'get',
    url: `${apiName}/storeLocation/getOptions`
  },
  // 根据ID查询店铺商品定位维护
  getStoreLocationByGoodsCode: {
    type: 'get',
    url: `${apiName}/storeLocation/getStoreLocationByGoodsCode`
  },
  // 店铺商品定位维护保存
  saveStoreLocation: {
    type: 'post',
    url: `${apiName}/storeLocation/saveStoreLocation`
  },
  addStoreLocation: {
    type: 'post',
    url: `${apiName}/storeLocation/addStoreLocation`
  },
  // 品类风格维护分页查询
  categoryStyleListPage: {
    type: 'post',
    url: `${apiName}/categoryStyle/listPage`
  },
  // 品类风格维护保存
  saveCategoryStyle: {
    type: 'post',
    url: `${apiName}/categoryStyle/saveCategoryStyle`
  },
  // 品类风格维护根据ID查询数据
  getCategoryStyleById: {
    type: 'get',
    url: `${apiName}/categoryStyle/getCategoryStyleById`
  },
  // 多层级分页查询
  hierarchyListPage: {
    type: 'post',
    url: `${apiName}/hierarchy/listPage`
  },
  // 商品销售价完整日志-用户阅读情况
  wholeLogReadStatus: {
    type: 'get',
    url: `${apiName}/sku/salesPrice/wholeLog/readStatus`
  },
  downloadGet: {
    type: 'get',
    url: `${apiName}/file/download`
  },
  listAuditor: {
    type: 'get',
    url: `${apiName}/sku/salesPrice/auditor/list`
  },
  updateGoodsSalesPrice: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/update`
  },
  insertGoodsSalesPrice: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/insertGoodsSalesPrice`
  },
  batchSubmission: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/submit`
  },
  batchAudit: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/audit`
  },
  removeGoodsSalesPrice: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/remove`
  },
  listSalesPriceAudit: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/audit/list`
  },
  listSalesPrice: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/list`
  },
  goodsPriceCoefficientList: {
    type: 'post',
    url: `${apiName}/goodsPriceCoefficient/list`
  },
  goodsPriceCoefficientUpdateById: {
    type: 'post',
    url: `${apiName}/goodsPriceCoefficient/updateById`
  },
  goodsPriceCoefficientInsertData: {
    type: 'post',
    url: `${apiName}/goodsPriceCoefficient/insertData`
  },
  listSalesPriceAdjustment: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/adjustment/list`
  },
  listMngSalesPrice: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/group/list`
  },
  listSalesPriceApprovalComment: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/comment/list`
  },
  listPrice: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/price/list`
  },
  baseAttrManager: {
    type: 'post',
    url: `${apiName}/goods/baseAttrManager`
  },
  baseAttrEdit: {
    type: 'post',
    url: `${apiName}/goods/baseAttrEdit`
  },
  getProductByGoodsCode: {
    type: 'post',
    url: `${apiName}/product/retailPrice/getProductByGoodsCode`
  },
  batchUpdateValidDate: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/price/batchUpdateValidDate`
  },
  salesPriceRemove: {
    type: 'post',
    url: `${apiName}/sku/salesPrice/remove`
  },
  columns: { //自定义列表查询
    type: 'get',
    url: `${apiName}/customize/columns`
  },
  operate: { //自定义列表保存
    type: 'post',
    url: `${apiName}/customize/operate`
  },
  deliverySaveOrUpdate: { //新增-修改发货周期
    type: 'post',
    url: `${apiName}/goods/delivery/forSale/saveOrUpdate`
  },
  changeListSearch: { //变更清单-分页
    type: 'post',
    url: `${apiName}/sku/salesPrice/changeList/search`
  },
  changeListRead: { //变更清单-已读
    type: 'post',
    url: `${apiName}/sku/salesPrice/changeList/read`
  },
  saleStatusUpdate: { //销售状态-更新
    type: 'post',
    url: `${apiName}/sku/salesPrice/saleStatus/update`
  },
  changeListExport: { //变更清单-导出
    type: 'post',
    url: `${apiName}/sku/salesPrice/changeList/export`
  },
  baseAttrBatchEdit: { //商品基础属性批量设置
    type: 'post',
    url: `${apiName}/goods/baseAttrBatchEdit`
  },
  salesStatuslist: { //商品销售状态筛选列表查询
    type: 'get',
    url: `${apiName}/sku/salesPrice/salesStatuslist`
  },
  pageGoodsLivePrice: { //达播价格维护分页查询
    type: 'post',
    url: `${apiName}/goodsLivePrice/pageGoodsLivePrice`
  },
  pageGoodsLivePriceLog: { //调整记录查询
    type: 'post',
    url: `${apiName}/goodsLivePrice/pageGoodsLivePriceLog`
  },
  queryGoodsInfos: { //达播价格维护查询商品信息
    type: 'post',
    url: `${apiName}/goodsLivePrice/queryGoodsInfos`
  },
  saveGoodsLivePrice: { //达播价格维护新增-编辑
    type: 'post',
    url: `${apiName}/goodsLivePrice/saveGoodsLivePrice`
  },
  //商品消息通知列表
  goodsInfoPage: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/msgNoticePage'
  },
  //再次立即通知
  reNotice: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/reNotice'
  },
  //商品消息通知店铺详情列表
  storeDetailPage: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/storeDetailPage'
  },
  //商品消息通知涉及商品、型号列表
  skuDetailPage: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/skuDetailPage'
  },
  //通知保存
  saveMsgNotice: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/saveMsgNotice'
  },
  //通知日志保存
  msgNoticeSaveLog: {
    type: 'post',
    url: '/ec-goods-new-api/msgNotice/saveLog'
  },

  //商品结算价维护
  goodsSettlementPricePage : {
    type: 'post',
    url: '/ec-pc-api/livePrice/goodsSettlementPricePage '
  },
  //查询商品结算价调整记录
  goodsSettlementPriceAdjustLog: {
    type: 'post',
    url: '/ec-pc-api/livePrice/goodsSettlementPriceAdjustLog'
  },
  //商品特殊直播价分页查询
  goodsSpecialLivePricePage: {
    type: 'post',
    url: '/ec-pc-api/livePrice/goodsSpecialLivePricePage'
  },
  //商品特殊直播价审批
  goodsLiveSpecialPriceApprove: {
    type: 'post',
    url: '/ec-pc-api/livePrice/goodsLiveSpecialPriceApprove'
  },
  //商品特殊直播价申请
  goodsLiveSpecialPriceApply: {
    type: 'post',
    url: '/ec-pc-api/livePrice/goodsLiveSpecialPriceApply'
  },
  //商品特殊直播价批量审批通过
  goodsLiveSpecialPriceBatchApprove: {
    type: 'post',
    url: '/ec-pc-api/livePrice/goodsLiveSpecialPriceBatchApprove'
  },
  //商品直播价分页查询
  goodsLivePricePage: {
    type: 'post',
    url: '/ec-pc-api/livePrice/goodsLivePricePage'
  },
  //商品直播价导入需特殊申请商品分页查询
  goodsLivePriceImportFailPage: {
    type: 'post',
    url: '/ec-pc-api/livePrice/goodsLivePriceImportFailPage'
  },
  //商品直播价新增
  goodsLivePriceAdd: {
    type: 'post',
    url: '/ec-pc-api/livePrice/goodsLivePriceAdd'
  },
  //轮询商品直播价导入状态
  goodsLivePriceImportStatus: {
    type: 'get',
    url: '/ec-pc-api/livePrice/goodsLivePriceImportStatus'
  },
  //商品特殊直播价批量申请
  goodsSpecialLivePriceBatchApprove: {
    type: 'get',
    url: '/ec-pc-api/livePrice/goodsSpecialLivePriceBatchApprove'
  },
};

export default goods;
